import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import TablaCircuitoCerealPesoTotalView from '../components/TablaCircuitoCerealPesoTotalView'
import { actualizarTablaCerealPesoTotal } from '../actions/TablaCamionesEnCircuitoActions'

function TablaCircuitoCerealPesoTotal (props) {
  const { actualizarTablaCerealPesoTotal } = props

  useEffect(() => {
    actualizarTablaCerealPesoTotal()
  }, [actualizarTablaCerealPesoTotal])

  return (<TablaCircuitoCerealPesoTotalView />)
}

const mapActionsToProps = {
  actualizarTablaCerealPesoTotal
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCircuitoCerealPesoTotal)
